export const validations = {
  code: [{ required: true, message: 'Verification code is required' }],
  firstName: [{ required: true, message: 'First name is required' }],
  lastName: [{ required: true, message: 'Last name is required' }],
};
